

export * from './characteristic-row-class-name.model';
export * from './pre-append-table-content.model';